import * as React from 'react';
import Die from './Die';

interface DieManagerProps {
	isDataCorrect: boolean;
	paymentInfo: EnteredPaymentInfo | null;
}

const DieManager: React.FunctionComponent<DieManagerProps> = ({ isDataCorrect, paymentInfo }) => (
	<Die isDataCorrect={isDataCorrect} paymentInfo={paymentInfo} />
);

export default DieManager;
